import React, { useState, useEffect } from "react";
import { useAuth } from "./useAuth";
import { useWords } from "./useWords";
import VotingScreen from "./components/VotingScreen";
import Leaderboard from "./components/Leaderboard";
import IntroBanner from "./components/IntroBanner";
import { track } from "./firebase";
import "./App.css";

export default function App() {
  const uid = useAuth();
  const { words, ready, error } = useWords();
  const [screen, setScreen] = useState("vote");

  useEffect(() => {
    if (ready) {
      track("screen_view", { screen_name: screen });
    }
  }, [screen, ready]);

  function switchScreen(s) {
    setScreen(s);
  }

  if (error) {
    return (
      <div className="app-error">
        <h2>Something went wrong</h2>
        <p>{error}</p>
      </div>
    );
  }

  return (
    <div className="app">
      <header className="app-header">
        <div className="header-inner">
          <div className="header-brand">
            <h1 className="app-logo">Punl</h1>
            <p className="app-tagline">We smashed words together. You pick the funniest.</p>
          </div>
          <nav className="header-nav">
            <button
              className={`nav-btn ${screen === "vote" ? "active" : ""}`}
              onClick={() => switchScreen("vote")}
            >
              Vote
            </button>
            <button
              className={`nav-btn ${screen === "leaderboard" ? "active" : ""}`}
              onClick={() => switchScreen("leaderboard")}
            >
              Leaderboard
            </button>
          </nav>
        </div>
      </header>

      <main className="app-main">
        {!ready || !uid ? (
          <div className="loading-state">
            <div className="loading-spinner" />
            <p>Loading words…</p>
          </div>
        ) : screen === "vote" ? (
          <div className="vote-page">
            <IntroBanner />
            <VotingScreen words={words} uid={uid} />
          </div>
        ) : (
          <Leaderboard />
        )}
      </main>
    </div>
  );
}
